// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AutomotiveRepairRouteImport } from './routes/automotive-repair'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FleetServiceRouteImport } from './routes/fleet-service'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ServiceAreaRouteImport } from './routes/service-area'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AutomotiveRepairRoute = AutomotiveRepairRouteImport.update({
            id: '/automotive-repair',path: '/automotive-repair',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FleetServiceRoute = FleetServiceRouteImport.update({
            id: '/fleet-service',path: '/fleet-service',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ServiceAreaRoute = ServiceAreaRouteImport.update({
            id: '/service-area',path: '/service-area',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AutomotiveRepairRoute: AutomotiveRepairRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,FleetServiceRoute: FleetServiceRoute,ReviewsRoute: ReviewsRoute,ServiceAreaRoute: ServiceAreaRoute,ServicesSlugRoute: ServicesSlugRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)